// import { FC } from 'react';
// import { ApiParam } from '../../../lib/interfaces/ApiControl';
// import './ApiControlEndpointTable.scss';

// type ApiControlEndpointTableProps = {
// 	data: ApiParam[];
// };

// const ApiControlEndpointTable: FC<ApiControlEndpointTableProps> = ({
// 	data,
// }) => (
// 	<div>
// 		<div className="ApiControlEndpointTable__header">
// 			<div>Name</div>
// 			<div>Description</div>
// 			<div>Type</div>
// 			<div>Required</div>
// 			<div>Example</div>
// 		</div>
// 		{data.map((item) => (
// 			<div className="ApiControlEndpointTable__row" key={item.id}>
// 				<div>{item.name}</div>
// 				<div>{item.description}</div>
// 				<div>{item.type}</div>
// 				<div>{item.required ? 'V' : '-'}</div>
// 				<div>{item.example}</div>
// 			</div>
// 		))}
// 	</div>
// );

// export default ApiControlEndpointTable;

import { FC } from 'react';
import { useSelector } from 'react-redux';
import DoneIcon from '@mui/icons-material/Done';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ApiParam } from '../../../lib/interfaces/ApiControl';
import CodeRow from '../../Simple/CodeRow/CodeRow';
import { RootState } from '../../../redux/store';

type ApiControlEndpointTableProps = {
	data: ApiParam[];
	withExamples?: boolean;
};

const ApiControlEndpointTable: FC<ApiControlEndpointTableProps> = ({
	data,
	withExamples,
}) => {
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	console.log(isDarkTheme);
	return (
		<TableContainer component={Paper} elevation={0}>
			<Table sx={{ minWidth: '100%' }} aria-label="caption table" size="small">
				<TableHead>
					<TableRow>
						<TableCell sx={{ width: '200px' }}>Name</TableCell>
						<TableCell align="left" sx={{ width: '100px' }}>
							Type
						</TableCell>
						<TableCell align="left" sx={{ width: '100px' }}>
							Required
						</TableCell>
						<TableCell
							align="left"
							sx={{ width: 'calc(100% - 100px -100px -200px)' }}
						>
							Description
						</TableCell>
						{withExamples && <TableCell align="left">Example</TableCell>}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map((row) => (
						<TableRow key={row.id}>
							<TableCell component="th" scope="row" sx={{ width: '200px' }}>
								<CodeRow row={row.name} language="javascript" withTheme />
							</TableCell>
							<TableCell align="left" sx={{ width: '100px' }}>
								{row.type}
							</TableCell>
							<TableCell align="left" sx={{ width: '100px' }}>
								{row.required ? <DoneIcon /> : ''}
							</TableCell>
							<TableCell
								align="left"
								sx={{ width: 'calc(100% - 100px -100px -200px)' }}
							>
								{row.description}
							</TableCell>
							{withExamples && (
								<TableCell align="left">
									{row.example ? (
										<CodeRow row={row.example} language="javascript" withTheme />
									) : null}
								</TableCell>
							)}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default ApiControlEndpointTable;
